import React, { useState } from "react";
import axios from "axios";
import FileUpload from "./FileUpload";
import dlCommon from "../../dlCommon";

const DlUnitFileFields = () => {
  const [unitFileNote, setUnitFileNote] = useState("");
  const [fileName, setFileName] = useState("");

  const fOpt = {
    upFoldPath: "up/",
    upOnSel: true,
  };

  const upAfter = (res) => {
    res = JSON.parse(res);
    setFileName(res.files[0].filename);
    console.log("upAfter", res.files[0].filename);
    // console.log(res);
  };

  const importClickHandle = async () => {
    const url = dlCommon.apiUrlGet("dl-custom", "file-fields");
    const item = {
      fileName,
    };
    console.log("importFileFields", url);
    await axios.post(url, item);
    setUnitFileNote("Uneti su zapisi preko fajla");
    setTimeout(() => {
      setUnitFileNote("");
    }, 5 * 1000);
    setFileName("");
  };

  const importCancelClickHandle = () => {
    setFileName("");
    console.log("importCancelClickHandle");
  };

  return (
    <div style={{ marginTop: "4rem" }}>
      <div>Unos zapisa preko fajla</div>
      {fileName && <div style={{ marginTop: "1rem" }}>{fileName}</div>}
      {unitFileNote && (
        <div style={{ marginTop: "1rem", color: "green" }}>{unitFileNote}</div>
      )}
      <div style={{ marginTop: "1rem" }}>
        <FileUpload fOpt={fOpt} fUpAfter={upAfter} />
      </div>
      {fileName && (
        <div style={{ marginTop: "1rem" }}>
          <button onClick={importClickHandle}>UNOS</button>
          <button
            onClick={importCancelClickHandle}
            style={{ marginLeft: "2rem" }}
          >
            ODUSTANI
          </button>
        </div>
      )}
    </div>
  );
};

export default DlUnitFileFields;
